<div class="jhmc-sent jhm-page" [class.mobile]="screenSize==='MOBILE'">
  <div class="jhm-top-toolbar">
	<div class="left">
	  <div class="title-item">
		<div class="fa-solid fa-bars nav-open" (click)="openNav()"></div>
		<div class="title">
		  Sent
		</div>
	  </div>
	</div>
	<div class="right">

	</div>
  </div>
  <jhm-table
	[refreshTableData]="refreshTableData"
	[repository]="messageRepository"
	[zeroState]="'sent'"
	(cellClicked)="cellClicked($event)">
  </jhm-table>
</div>
@if (showConfirmDeleteModal) {
  <div class="jhm-modal-background">
	<div id="delete-draft-modal" class="jhm-modal delete-draft-modal">
	  <header>
		<h2>Delete Message?</h2>
	  </header>
	  <div>
		Are you sure you'd like to delete this message?
	  </div>
	  <footer class="filled">
		<button class="jhm-button" (click)="showConfirmDeleteModal = false">Cancel</button>
		<button class="jhm-button primary" (click)="deleteMessage()">Delete</button>
	  </footer>
	</div>
  </div>
}